import { i18n } from 'i18next';
import { convertUnit } from './convertUnit';

/**
 * Method to add formatters to i18next
 *
 *
 * @example Convert a value from one unit to another, provide value and fromUnit, optional toUnit (second argument)
 * ```json
 * {
 *  "localizationKey": "example text: {{value, convertUnit('MB')}}",
 *  "localizationKey": "example text: {{value, convertUnit('MB', 'GB')}}"
 * }
 * ```
 */
export const addFormatters = (i18next: i18n) => {
  i18next.services.formatter?.add('convertUnit', convertUnit);
};
